import React, { createContext, useState, useEffect } from "react";

import useHTTP from "@/components/hooks/useHTTP";
import { getAppGuid } from "@/components/elements/search/utility";
import { ContentSearchRequest } from "@/components/elements/search/interfaces/Search";

export interface ISearchLanding {
    lastSearches: any[]
    recentlyViewed: any[]
    recentlyPublished: any[]
    myRecentlyPublished: any[]
    recentDrafts: any[]  
    isLoading: boolean
    getHistory: () => void
    getRecentlyPublished: () => void
    getMyRecentlyPublished: () => void
    getRecentDrafts: () => void
    clearSearchHistory: () => void

}

export const searchLandingDefaults:ISearchLanding = {
    lastSearches: [],
    recentlyViewed: [],
    recentlyPublished: [],
    myRecentlyPublished: [],
    recentDrafts: [],
    isLoading: false,
    getHistory: () => {},
    getRecentlyPublished: () => {},
    getMyRecentlyPublished: () => {},
    getRecentDrafts: () => {},
    clearSearchHistory: () => {}
}

export const SearchLandingContext = createContext(searchLandingDefaults);


const SearchLandingProvider = ({ searchDirty, setSearchDirty, setLastSearchTerms, children }:{searchDirty:boolean, setSearchDirty: (val:boolean) => void, setLastSearchTerms: (lastSearch: ContentSearchRequest) => void, children:React.ReactNode}) => {

    const [lastSearches, setLastSearches] = useState<any[]>([]) 
    const [recentlyViewed, setRecentlyViewed] = useState<any[]>([]) 
    const [recentlyPublished, setRecentlyPublished] = useState<any[]>([]) 
    const [myRecentlyPublished, setMyRecentlyPublished] = useState<any[]>([]) 
    const [recentDrafts, setRecentDrafts] = useState<any[]>([]) 
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const { get, remove} = useHTTP();

    useEffect(() => {
        setIsLoading(true)
    }, [])

    async function getHistory() {
        if (searchDirty) {
            setSearchDirty(false);
            await remove(`/search/app/${getAppGuid()}/me/lastsearchterms`, {})
            .catch(() => {/* do nothing - prevents axios halthing the function  */})
        }

        get(`search/app/${getAppGuid()}/me/history?top=5`)
            .then(({data}) => {
                setLastSearches(data.recentlySearched.slice(0, 5))
                setRecentlyViewed(data.recentlyViewed)
                setLastSearchTerms(data.lastSearchDefaults)
            })
            .finally(() => {
                setIsLoading(false);
        })
    }

    function clearSearchHistory() {
        remove(`search/app/${getAppGuid()}/me/history/recentlysearched`, {})
        .catch(err => console.log(err))
        .finally(() => getHistory())
    }

    function getRecentlyPublished() {
        get(`search/app/${getAppGuid()}/recentlypublished?top=20`)
            .then(({data}) => {
                setRecentlyPublished(data.items)
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    function getMyRecentlyPublished() {
        get(`search/app/${getAppGuid()}/me/recentlypublished?top=20`)
            .then(({data}) => {
                setMyRecentlyPublished(data.items)
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    function getRecentDrafts(){
        get(`search/app/${getAppGuid()}/me/recentdrafts?top=20`)
            .then(({data}) => {
                setRecentDrafts(data.items)
            })
            .finally(() => {
                setIsLoading(false);
            })
    }


    const context = {lastSearches, recentlyViewed, recentlyPublished, myRecentlyPublished, recentDrafts, isLoading, getRecentlyPublished, getRecentDrafts, getHistory, clearSearchHistory, getMyRecentlyPublished}

    return (
        <SearchLandingContext.Provider value={context}>
            {children}
        </SearchLandingContext.Provider>
    )
}

export default SearchLandingProvider;
